//noinspection JSHint
/**
 * Kann den Content zwischen Tabs hin und herschalten. Aktuell kann dieser Controller nur mit einem Tab pro Root-Content-Div umgehen. Er muss daher auch mit einem DIV erstellt werden.
 */
import $ from "jquery";

export default function TabController() {
}

/**
 * @param $root Solle nie über AJAX ausgetauscht werden, damit man hier mit LIVE Events arbeiten kann und sich nicht immer neu intialisieren muss.
 */
TabController.prototype.initForRootElement = function ($root) {
  $root.on("click", "[data-tab-id]", function () {
    var $this = $(this);
    var tabId = $this.attr("data-tab-id");
    // Bei allen Tabs die active Klasse entfernen.
    $root.find("[data-tab-id]").each(function () {
      $(this).removeClass("active");
      $(this).removeClass("product-filter-header__tab__default-active");
    });
    // Dem aktuellen Tab die aktive Klasse hinzufügen
    $this.addClass("active");
    // Danach den Content des geklickten Tabs anzeigen und den für die anderen ausblenden
    $root.find("[data-show-only-in-tab]").each(function () {
      var $tabContent = $(this);
      var tabContentTabId = $tabContent.attr("data-show-only-in-tab");
      if (tabContentTabId === tabId) {
        $tabContent.show();
        $tabContent.removeClass("jh-hidden-important");
      } else {
        // muss mit important gesetzt werden, da einige Klasse das block auch mit important setzen
        $tabContent.addClass("jh-hidden-important");
      }
    });
  });
};

TabController.prototype.initForProductList = function () {
  var _this = this;
  $(document).ready(function () {
    // da wir hier das document als root setzen, kann es nur Tabs auf der Produktliste nur einmal geben.
    // Würde es mehrere geben, würde der Listener falsch reagieren.
    _this.initForRootElement($(document));
  });
};


